import React, { useState, useEffect } from 'react'
import 'antd/lib/select/style/index.css'
import classNames from 'classnames'
import { LIMIT } from "../../helpers/filtersTable"
import { Card, CardBody, Col, Row } from "reactstrap"
import { Select, message } from "antd"
import FilterStore from './filter/FilterStore'
import FilterUpdateAt from './filter/FilterUpdateAt'
import PriorityStoreTable from './table/PriorityStoreTable'
import ReactPaginate from "react-paginate"
import CreatePriorityStore from './CreatePriorityStore'
import { getListPriorityStore, getDetailPriorityStore } from "../../../services/api/apiReGenerateLabel"
import { getAllProductType } from "../../../services/api/apiSku"

const { Option } = Select


const PriorityStorePage = () => {

    const [limit, setLimit] = useState(50)
    const [total, setTotal] = useState(0)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [page, setPage] = useState(1)
    const [nameSpace, setNameSpace] = useState('')
    const [updated, setUpdated] = useState('')
    const [modal, setModal] = useState(false)
    const [listStore, setListStore] = useState([])
    const [err, setErr] = useState(true)
    const [listProductType, setListProductType] = useState([])

    const pages = Math.ceil(total / limit)

    const _handleChangeLimit = (limit) => {
        setLimit(limit)
        setPage(1)
    }

    const _handleChangeName = value => {
        setNameSpace(value)
        setPage(1)
    }

    const _handleChangeDate = filter => {
        setUpdated({ ...filter })
        setPage(1)
    }

    const _handlePageClick = page => {
        if (!page || typeof page !== 'object') return false

        const { selected } = page
        const vPage = selected > 0 ? parseInt(selected, 10) : 0

        setPage(vPage + 1)
    }

    const toggle = () => setModal(!modal)

    const _fetchListSku = async () => {
        try {
            const payload = {
                is_deleted: false,
            }

            const { data: response } = await getAllProductType(payload)

            const { success, data, message } = response

            if (!success) {
                return setErr(message)
            }

            if (data.length > 0) {
                const listTypes = data.map(itemProduct => ({
                    label: itemProduct.sku,
                    value: itemProduct.sku
                }))
                setListProductType(listTypes)
            }
        } catch (err) {
            setErr(err.message)
        }
    }

    const _getDetailStore = async (id, setNewStore, setIsAllStore, setProductType) => {
        try {
            const { data: response } = await getDetailPriorityStore(id)
            const { data, success, message: mes } = response

            if (!success) {
                setModal()
                return message.error(mes)
            }

            const { namespace, product_types, apply_for_all = false } = data
            setNewStore(namespace)
            setIsAllStore(apply_for_all)
            setProductType(product_types)
        } catch (e) {
            throw new Error(e.message)
        }
    }

    useEffect(() => {
        _fetchListSku()
    }, [])

    const _fetchListPriorityStore = async () => {
        setLoading(true)
        setError('')

        try {
            const payload = {
                page, limit,
            }

            if (!!nameSpace) payload.namespace = nameSpace.trim()
            if (!!updated) payload.updated_at = updated.update_at

            const { data: response } = await getListPriorityStore(payload)
            const { success, message, data } = response
            if (!success) throw new Error(message)

            const { stores, total } = data

            setListStore(stores)
            setTotal(total || 0)
            setLoading(false)

        } catch (e) {
            setLoading(false)
            setError(e.message)
        }
    }

    useEffect(() => {
        _fetchListPriorityStore()
    }, [page, limit, nameSpace, updated])

    return (
        <div className='PriorityStorePage'>
            <Card>
                <div className="CardHeader card-header header-elements-inline">
                    <div className="header-elements d-flex justify-content-between align-items-center w-100">
                        <h1 className='card-title'>Danh sách ưu tiên</h1>
                        <div className="actions">
                            <button className="btn btn-primary" onClick={toggle}>Add store</button>
                            <CreatePriorityStore
                                toggle={toggle}
                                modal={modal}
                                setModal={setModal}
                                reload={_fetchListPriorityStore}
                                listProductType={listProductType}
                                err={err}
                                listStore={listStore}
                            />
                        </div>
                    </div>
                </div>
                <CardBody>
                    <div className="PriorityStoreFilters mb-3 pt-3 pl-3 pr-3">
                        <Row form>
                            <Col md={3}>
                                <FilterStore
                                    nameSpace={nameSpace}
                                    handleChangeName={_handleChangeName}
                                />
                            </Col>
                            <Col md={3}>
                                <FilterUpdateAt
                                    handleChangeDate={_handleChangeDate}
                                    updated={updated}
                                />
                            </Col>
                        </Row>
                    </div>

                    <div className="d-flex justify-content-end mb-3">
                        <div className='d-flex align-items-center justify-content-end'>
                            <div className='d-flex align-items-center ml-3'>
                                <div>Hiển thị</div>
                                <Select
                                    style={{ width: 100 }}
                                    showArrow={true}
                                    defaultValue={limit}
                                    className="ml-1"
                                    onChange={_handleChangeLimit}
                                    value={limit}
                                >
                                    {
                                        LIMIT.map(item => {
                                            return <Option key={item.value} value={item.value}>{item.name}</Option>
                                        })
                                    }
                                </Select>

                                <div className='ml-3'>Tổng số: <span className='font-weight-bold'>{total || 0}</span> stores</div>
                            </div>
                        </div>
                    </div>

                    <PriorityStoreTable
                        listStore={listStore}
                        loading={loading}
                        error={error}
                        listProductType={listProductType}
                        reload={_fetchListPriorityStore}
                        setModal={setModal}
                        getDetailStore={_getDetailStore}
                    />

                    <div className="mt-3 float-right">
                        <div className="NextPagination">
                            <ReactPaginate
                                forcePage={page - 1}
                                previousLabel='Previous'
                                previousClassName='page-item previous'
                                previousLinkClassName='page-link'
                                nextLabel='Next'
                                nextClassName='page-item next'
                                nextLinkClassName='page-link'
                                breakLabel='...'
                                breakClassName='break-me'
                                pageCount={pages}
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={5}
                                onPageChange={_handlePageClick}
                                containerClassName={classNames('pagination', { loading })}
                                pageClassName='page-item'
                                pageLinkClassName='page-link'
                                activeClassName='active' />
                        </div>
                    </div>

                </CardBody>
            </Card>
        </div>
    )
}

export default PriorityStorePage